import { Autocomplete, Box, Button, Chip, Divider, FormControl, FormControlLabel, Grid, IconButton, InputLabel, Menu, MenuItem, Radio, RadioGroup, Select, Stack, Tab, Tabs, TextField, Tooltip, Typography, useTheme } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import PromptSelectDropdown from "../components/common/promptComponents/promptSelectDropdown";
import { locationsSelector } from "../../store/slices/location";
import { useDispatch, useSelector } from "react-redux";
import { convertArrayToDictionary, defaultGuid, generateExcelFile, normalizeReasoningEffort } from "../../common/utils";
import { isValidJSON } from "../components/common/reviewComponents/reviewUtils";
import { logSelector } from "../../store/slices/logs";
import { reviewsSelector, triggerExecutePromptMultiple } from "../../store/slices/reviews";
import _, { get, set } from "lodash";
import { v4 as uuidv4 } from 'uuid';
import { handlePromptPreview } from "../components/common/reviewComponents/customizeResponse";
import { companiesSelector } from "../../store/slices/company";
import ReactJson from "react-json-view";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { factsSelector, setFactLocalState } from "../../store/slices/facts";
import { getOtherFilter } from "../../common/utils/setOtherFilter";
import moment from "moment";
import { LoadingButton } from "@mui/lab";


const Facts = ({selectedCompany, userRoles}) => {
    const [promptId, setPromptId] = useState(null);
    const [promptName, setPromptName] = useState("");
    const [nextPromptId, setNextPromptId] = useState(null);
    const [nextPromptId2, setNextPromptId2] = useState(null);
    const [nextPromptName, setNextPromptName] = useState("");
    const [executedPromptId, setExecutedPromptId] = useState("");
    const [customSettings, setCustomsettings] = useState({
        executeParallel: true,
        singleReview: false,
      });
    const [previousResponseId, setPreviousResponseId] = useState(null);
    // const [promptsInput, setPromptsInput] = useState({});
    const [websiteUrl, setWebsiteUrl] = useState("");
    const [reviewCount1, setReviewCount1] = useState(1000);
    const [reviewCount2, setReviewCount2] = useState(1000);
    const [selectedTab, setSelectedTab] = useState(1);
    const [previousResponseIds, setPreviousResponseIds] = useState('');
    const [isCopied, setIsCopied] = useState(false);
    const [isIoCopied, setIsIoCopied] = useState(false);
    const [displayType, setDisplayType] = useState("visual");
    const [executionType, setExecutionType] = useState('response'); 

    const { prompts } = useSelector(locationsSelector);
    const { apiKey } = useSelector(logSelector);
    const { reviews, executePromptMultiple, executePromptMultipleFact, loadingExecutePromptMultiple } = useSelector(reviewsSelector);
    const { companies } = useSelector(companiesSelector);
    const {localState:{factDevelopment, FactData}} = useSelector(factsSelector);
    const inputData = useMemo(()=>{
    
    const inputData = factDevelopment?.inputData || {};
    return inputData;
},[factDevelopment]);
    const companyData = React.useMemo(
    () => _.find(companies, { companyId: selectedCompany }),
    [companies, selectedCompany]
    );

    const isIRUser = useMemo(() => userRoles?.indexOf("IRUser") >= 0, [userRoles]);
    const dispatch = useDispatch();
    const promptsDic = useMemo(() => {
        return convertArrayToDictionary(prompts, "promptId");
    }, [prompts]);
    const reviewDic = useMemo(() => {
        const reviewsSubset = _.clone(reviews);
        return convertArrayToDictionary(reviewsSubset, "reviewId");
    }, [reviews]);
    const filteredPrompts = useMemo(() => {
        return prompts?.filter(p => p.type === "Business"&& p.subType==="Facts") || [];
    }, [prompts]);

    const websiteResearchPrompts = useMemo(() => {
        return prompts?.filter(p => p.type === "Business"&& p.subType==="Website Research") || [];
    }, [prompts]);
   
    const nextPromt = useMemo(()=>{
        return filteredPrompts.filter(p=>p.promptId!==promptId);
    },[filteredPrompts,promptId]);
    
    const reviewIds = useCallback((type)=>{
        const count = type==="responseId"
          ? parseInt(inputData?.reviewCount2 ?? reviewCount2, 10)
          : parseInt(inputData?.reviewCount1 ?? reviewCount1, 10);
        const firstThousand = _.slice(_.orderBy(_.filter(_.clone(reviews), r => r.reviewText), ['reviewUpdateTime', 'desc']),0, count || 0);
        return _.map(firstThousand,'reviewId');
    },[reviews, reviewCount2, reviewCount1, inputData]);

    const promptOutPut = React.useMemo(() => isValidJSON(executePromptMultiple?.[ executedPromptId]?.[0]) ? JSON.parse(executePromptMultiple?.[executedPromptId]?.[0]) : null, [executePromptMultiple, executedPromptId])

    // useEffect(()=>{
        
    //      const data = _.map(reviewIds, it => ({
    //               ReviewId: it,
    //               Review: reviewDic[it]?.reviewText,
    //               Rating: reviewDic[it]?.rating,
    //               Response: reviewDic[it]?.responseText
    //             }))
               
    //     setPromptsInput({
    //         ReviewsForFactDevelopment: JSON.stringify(data)
    //     })
    // },[ reviewIds, reviews]);
    const usedPromptId = useCallback((type)=>(type==="responseId" ? inputData?.factDevelopmentPromptId2 : inputData?.websiteResearchPromptId), [inputData]);
    const defaultParameters = useCallback((type=null) => {
        return isValidJSON(promptsDic?.[usedPromptId(type)]?.defaultParameters) ? JSON.parse(promptsDic?.[usedPromptId(type)]?.defaultParameters) : {};
    },[promptsDic, inputData, inputData]);
    
    const getFactsCollection = (data) =>
        data?.["Facts output"] ||
        data?.["Fact Output"] ||
        data?.["Fact output"] ||
        data?.FactData ||
        data?.factData ||
        {};

    const parseResponseContent = (dt) => {
        const raw = Array.isArray(dt?.responseContent) ? dt?.responseContent?.[0] : dt?.responseContent;
        if (raw == null || raw === '') return {};
        if (typeof raw === 'object') return raw;
        return isValidJSON(raw) ? JSON.parse(raw) : {};
    };

    const WRPromptOutput = React.useMemo(() => {
        const dt = factDevelopment?.outputData || {};
        const parsedContent = parseResponseContent(dt);
        const checkOutput = _.has(parsedContent, 'MarketingStatements') || _.has(parsedContent, 'WebsiteMarketingStatements'); 
        if (checkOutput) {
            return parsedContent;
        } else {
            const data = dt?.previousResponse?.[0]?.Content ?? dt?.previousResponse?.[0]?.content ?? {};
            return isValidJSON(data) ? JSON.parse(data) : null;
        }

    }, [factDevelopment, promptId, selectedTab, displayType])   
    
    
     const buildExecutePayload = (type, wrOutputOverride = null) => {
        const requestId = uuidv4();
        const isFdaOnly = type === "responseId";
        const mainPromptId = isFdaOnly
          ? inputData?.factDevelopmentPromptId2
          : inputData?.websiteResearchPromptId;
        // FDA / both use reviewCount2; WR alone prefers reviewCount1 then reviewCount2
        const ids = reviewIds(isFdaOnly ? "responseId" : (inputData?.reviewCount1 ? "researchPrompt" : "responseId"));
        const data = _.map(ids, it => ({
                  ReviewId: it,
                  Review: reviewDic[it]?.reviewText,
                  Rating: reviewDic[it]?.rating,
                  Response: reviewDic[it]?.responseText
                }));
        const promptsInput = {
          ReviewsForFactDevelopment: JSON.stringify(data),
          TotalReviewsWithText: _.toString(_.size(data)),
          UpperBoundPct: _.toString(_.parseInt(_.size(data) * 0.2)),
        };
        const wrOutput = wrOutputOverride || WRPromptOutput;
        const useWrResult = isFdaOnly && (wrOutputOverride || inputData?.executionType === "response");
        const Input = handlePromptPreview(selectedCompany);
        const inputValues = _.isEmpty(Input)
          ? {
              ...promptsInput,
              WebsiteUrl: inputData?.websiteUrl || websiteUrl,
              WebsiteResearch: useWrResult
                ? JSON.stringify(wrOutput?.MarketingStatements ?? wrOutput?.WebsiteMarketingStatements)
                : null,
              WebsiteResearch_Output: useWrResult ? JSON.stringify(wrOutput) : null,
            }
          : {
              ...Input,
              ...promptsInput,
              AboutUs: companyData?.description ?? '',
              WebsiteUrl: inputData?.websiteUrl || websiteUrl,
              WebsiteResearch: useWrResult
                ? JSON.stringify(wrOutput?.MarketingStatements ?? wrOutput?.WebsiteMarketingStatements)
                : null,
              WebsiteResearch_Output: useWrResult ? JSON.stringify(wrOutput) : null,
            };

        const defaultP = isFdaOnly ? defaultParameters("responseId") : defaultParameters("researchPrompt");
        const cachingKey = promptsDic?.[mainPromptId]?.cachingKey;
        const PromptInput = {
          prompt: {
            Prompt: promptsDic?.[mainPromptId]?.promptText,
            systemPrompt: promptsDic?.[mainPromptId]?.systemPrompt,
            temperature: defaultP?.temperature == null ? null : parseFloat(defaultP?.temperature),
            maxLength: parseInt(defaultP?.maxLength),
            topP: defaultP?.topP == null ? null : parseFloat(defaultP?.topP),
            isContainsMaxInput: false,
            llm: promptsDic?.[mainPromptId]?.llm,
            seed: defaultP?.seed,
            presencePenalty: parseFloat(defaultP?.presencePenalty),
            jsonResponse: defaultP?.jsonResponse ? defaultP?.jsonResponse : false,
            frequencyPenalty: parseFloat(defaultP?.frequencyPenalty),
            companyId: selectedCompany ? selectedCompany : defaultGuid,
            isJsonResponseSchema: defaultP?.isJsonResponseSchema,
            responseJsonSchema: promptsDic?.[mainPromptId]?.responseJsonSchema,
            verbosity: defaultP?.verbosity ? _.toLower(defaultP?.verbosity) : null,
            reasoningEffort: defaultP?.reasoning_effort ? _.toLower(normalizeReasoningEffort(promptsDic?.[mainPromptId]?.llm, defaultP?.reasoning_effort)) : null,
            api: defaultP?.api ?? "completions",
            nextPromptId: isFdaOnly ? null : (inputData?.factDevelopmentPromptId1 || null),
            CachingKey: cachingKey ? cachingKey : null,
            WebSearch: defaultP?.web_search == null ? null : defaultP?.web_search,
            previousResponseId:
              isFdaOnly && !wrOutputOverride && inputData?.executionType === "responseId"
                ? inputData?.previousResponseId
                : null,
          },
          Parallel: customSettings?.executeParallel,
          Data: [],
          ProcessSingleReview: customSettings?.singleReview,
          Input: inputValues,
        };
        const ExtraData = {
          PromptId: mainPromptId,
          ReviewId: ids?.[0],
          PromptName: promptsDic?.[mainPromptId]?.name,
          PromptType: promptsDic?.[mainPromptId]?.type,
          PromptSubType: promptsDic?.[mainPromptId]?.subType,
          RequestId: requestId,
          apiKey: apiKey,
          id: null,
          subType: promptsDic?.[mainPromptId]?.subType,
        };
        return { PromptInput, ExtraData, mainPromptId };
      };

      const parseWrOutputFromResponse = (response) => {
        const raw = Array.isArray(response?.responseContent)
          ? response?.responseContent?.[0]
          : response?.responseContent;
        if (raw != null && typeof raw === 'object') return raw;
        if (isValidJSON(raw)) {
          const parsed = JSON.parse(raw);
          if (_.has(parsed, 'MarketingStatements') || _.has(parsed, 'WebsiteMarketingStatements')) {
            return parsed;
          }
        }
        const prev = response?.previousResponse?.[0]?.Content ?? response?.previousResponse?.[0]?.content ?? {};
        if (isValidJSON(prev)) return JSON.parse(prev);
        return typeof prev === 'object' ? prev : null;
      };

      const handleExecutePrompt = async (type) => {
        // Execute Both: WR first, then FDA using that WR response
        if (type === "both") {
          setExecutedPromptId(inputData?.websiteResearchPromptId);
          const wrPayload = buildExecutePayload("researchPrompt");
          // Ensure WR alone does not chain nextPromptId
          wrPayload.PromptInput.prompt.nextPromptId = null;

          const wrResponse = await dispatch(
            triggerExecutePromptMultiple(
              { PromptInput: wrPayload.PromptInput, ExtraData: wrPayload.ExtraData },
              selectedCompany,
              wrPayload.mainPromptId
            )
          );
          if (!wrResponse) return;

          const wrOutput = parseWrOutputFromResponse(wrResponse);
          if (!wrOutput) return;

          setExecutedPromptId(inputData?.factDevelopmentPromptId2);
          const fdaPayload = buildExecutePayload("responseId", wrOutput);
          await dispatch(
            triggerExecutePromptMultiple(
              { PromptInput: fdaPayload.PromptInput, ExtraData: fdaPayload.ExtraData },
              selectedCompany,
              fdaPayload.mainPromptId
            )
          );
          return;
        }

        const { PromptInput, ExtraData, mainPromptId } = buildExecutePayload(type);
        setExecutedPromptId(mainPromptId);
        await dispatch(
          triggerExecutePromptMultiple({ PromptInput, ExtraData }, selectedCompany, mainPromptId)
        );
      };
    
      const handleFirstCountChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setReviewCount1(value);
        }
        };
      const handleSecondCountChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setReviewCount2(value);
        }
        };


    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const outputData = React.useMemo(() => {
        if (selectedTab === 1) {
            const dt = factDevelopment?.outputData || {};
            const parsedContent = parseResponseContent(dt);
            const checkOutput =
                _.has(parsedContent, 'MarketingStatements') ||
                _.has(parsedContent, 'WebsiteMarketingStatements');

            setPreviousResponseIds(
                dt?.previousResponse?.[0]
                    ? (dt?.previousResponse?.[0]?.ResponseId || dt?.previousResponse?.[0]?.responseId)
                    : previousResponseIds || ''
            );

            if (checkOutput) {
                return parsedContent;
            }
            const data = dt?.previousResponse?.[0]?.Content ?? dt?.previousResponse?.[0]?.content ?? {};
            return isValidJSON(data) ? JSON.parse(data) : null;
        }

        // Tab 2 — Fact Development: bind only when Fact Development data exists
        const fdDt = FactData?.outputData;
        if (fdDt && _.size(fdDt) > 0) {
            const fdParsed = parseResponseContent(fdDt);
            if (_.size(fdParsed) > 0) {
                return fdParsed;
            }
            // Some payloads store facts at top-level without responseContent wrapper
            if (_.size(getFactsCollection(fdDt)) > 0) {
                return fdDt;
            }
            return fdParsed;
        }

        // Fallback for older chained WR→FD stored on factDevelopment (no MarketingStatements)
        const wrDt = factDevelopment?.outputData || {};
        const wrParsed = parseResponseContent(wrDt);
        const isWrOnly =
            _.has(wrParsed, 'MarketingStatements') ||
            _.has(wrParsed, 'WebsiteMarketingStatements');
        if (isWrOnly) {
            return {};
        }
        if (_.size(getFactsCollection(wrParsed)) > 0 || _.size(wrParsed) > 0) {
            return wrParsed;
        }

        return {};
    }, [factDevelopment, FactData, promptId, selectedTab, displayType])   
    

    const handleResponseIdCopy=()=>{
        if(previousResponseIds){
            setIsCopied(true);  
            return navigator.clipboard.writeText(previousResponseIds);
        }
    }

    const parseGptIoValue = (value) => {
        if (value == null || value === '') return {};
        if (typeof value === 'object') return value;
        if (isValidJSON(value)) return JSON.parse(value);
        return value;
    };

    const handleCopyInputOutput = () => {
        const wrDt = factDevelopment?.outputData || {};
        const fdDt = FactData?.outputData || {};
        const wrGpt = wrDt?.GPTData || wrDt?.gptData || [];
        const fdGpt = fdDt?.GPTData || fdDt?.gptData || [];
        const wrList = Array.isArray(wrGpt) ? wrGpt : (wrGpt ? [wrGpt] : []);
        const fdList = Array.isArray(fdGpt) ? fdGpt : (fdGpt ? [fdGpt] : []);

        let websiteResearch = {};
        let factDev = {};

        // Prefer dedicated FactData after FD re-runs; don't keep stale chained GPTData[1]
        if (fdList.length >= 1) {
            websiteResearch = wrList[0] || {};
            factDev = fdList[fdList.length - 1] || {};
        } else if (wrList.length > 1) {
            // Chained WR→FD stored on factDevelopment
            websiteResearch = wrList[0] || {};
            factDev = wrList[wrList.length - 1] || {};
        } else if (wrList.length === 1) {
            const parsedContent = parseResponseContent(wrDt);
            if (_.has(parsedContent, 'MarketingStatements') || _.has(parsedContent, 'WebsiteMarketingStatements')) {
                websiteResearch = wrList[0] || {};
            } else {
                factDev = wrList[0] || {};
            }
        }

        const wrInput = parseGptIoValue(websiteResearch?.Input ?? websiteResearch?.input);
        const wrOutput = parseGptIoValue(websiteResearch?.Output ?? websiteResearch?.output);
        const fdInput = parseGptIoValue(factDev?.Input ?? factDev?.input);
        const fdOutput = parseGptIoValue(factDev?.Output ?? factDev?.output);

        const clipboardText = [
            'Website Research Input:',
            JSON.stringify(wrInput, null, 2),
            'Website Research Output:',
            JSON.stringify(wrOutput, null, 2),
            'Fact development Input:',
            JSON.stringify(fdInput, null, 2),
            'Fact development Output:',
            JSON.stringify(fdOutput, null, 2),
        ].join('\n');

        navigator.clipboard.writeText(clipboardText);
        setIsIoCopied(true);
    };

    // Reset copy status when new prompt results arrive
    useEffect(() => {
        setIsIoCopied(false);
    }, [factDevelopment?.outputData?.createdAt, FactData?.outputData?.createdAt]);

    useEffect(()=>{
        if(isCopied){
            const timer = setTimeout(()=>{
                setIsCopied(false);
            },2000)

            return ()=>clearTimeout(timer);
        }
    },[isCopied])

    useEffect(()=>{
        if(isIoCopied){
            const timer = setTimeout(()=>{
                setIsIoCopied(false);
            },2000)

            return ()=>clearTimeout(timer);
        }
    },[isIoCopied])

    const handleChange = (event)=>{
        const {name, value} = event.target;
        const data = {...factDevelopment?.inputData}
        
        if(name==='reviewCount1' || name==='reviewCount2'){
              if (/^\d*$/.test(value)) {
                  data[name] = value;
                  
            }else{
                data[name] = '';
            }
            
        }else{
            data[name] = value;

        }
        
        dispatch(setFactLocalState({key:'factDevelopment', data:{...factDevelopment, inputData:data}, type:'factInputData'}));
    }

    useEffect(()=>{
        const data = getOtherFilter('factDevelopment');
        const parsedDt = isValidJSON(data) ? JSON.parse(data) :{};
        const factDataRaw = getOtherFilter('FactData');
        const parsedFactData = isValidJSON(factDataRaw) ? JSON.parse(factDataRaw) : {};
        const inputData = getOtherFilter('factInputData', false);
        const finalInputData = parsedDt?.inputData ? parsedDt.inputData: inputData || {};
        
        dispatch(setFactLocalState({key:'factDevelopment', data:{...factDevelopment, inputData:{...finalInputData, websiteUrl: parsedDt?.websiteUrl ?? companyData?.websiteUrl, 
            previousResponseId: parsedDt?.previousResponse?.[0]?.ResponseId ?? parsedDt?.previousResponse?.[0]?.responseId ?? '', executionType: 'response', reviewCount2: finalInputData?.reviewCount2 || 1000, websiteResearchPromptId: parsedDt?.websiteResearchPromptId ?? inputData?.websiteResearchPromptId??''}, outputData:parsedDt}, type:'factInputData'}));

        if (parsedFactData && _.size(parsedFactData) > 0) {
            dispatch(setFactLocalState({ key: 'FactData', data: { outputData: parsedFactData } }));
        } else {
            dispatch(setFactLocalState({ key: 'FactData', data: null }));
        }
    },[prompts, selectedCompany]);


const handleExport = ()=>{
    if(selectedTab===1){
    const websiteResearch = _.flattenDeep(outputData?.MarketingStatements ?? outputData?.WebsiteMarketingStatements)??[]
    const fileName = `${companyData?.name??''}_WRA_${moment().format('YYYYMMDD_HHmmss')}`
    const columns = [
        {
            key: 'area',
            header: 'Area',
        },
        {
            key: 'theme',
            header: 'Theme',
        },
        {
            key: 'statement',
            header: 'Statement',
        },
        {
            key: 'page',
            header: 'Page',
        },
    ]
         
    return generateExcelFile(websiteResearch, fileName, columns)
} else if(selectedTab ===2){
    const flatternData = [];
    const fdData = _.forEach(getFactsCollection(outputData), (data, key)=>{
        let finalData = _.cloneDeep(data);
        if (!Array.isArray(data)) {
            finalData = [data];
        }
        // flatternData.push({key:key, data:''});
        _.map(finalData, (it, idx)=>{
            flatternData.push({category: idx===0?key:'', ifThen:"If", fact:it?.If?.text??'', provenance:it?.provenance??'', response_info:it?.response_info || ""});
            _.map(it?.Then, (t, index)=>{
                flatternData.push({category: '', ifThen: index===0?"Then":"", fact:t?.text??'', provenance:t?.provenance??'', response_info:t?.response_info || ""})
            })
        })
    });

   const fileName = `${companyData?.name??''}_FDA_${moment().format('YYYYMMDD_HHmmss')}`

    const columns = [
        {
            key:'category',
            header: 'Category'
        },
        {
            key:'ifThen',
            header: 'If Then'
        },
        {
            key:'fact',
            header: 'Fact'
        },
        {
            key:'provenance',
            header: 'Provenance'
        },
        {
            key:'response_info',
            header: 'Response Info'
        },
    ]

    return generateExcelFile(flatternData, fileName, columns);
}
    
}

const theme = useTheme();
   
  return (
    <Box>
        <Typography variant="body1" sx={{ pt: 3, mb: 2, fontWeight: 'bold' }}>Select Prompt</Typography>
        <Grid container spacing={4}>
            <Grid item xs={5} >
                <Stack spacing={2}>
                      <Stack spacing={2}>
                          <PromptSelectDropdown
                              responsePrompts={websiteResearchPrompts}
                              promptId={inputData.websiteResearchPromptId ?? ""}
                              promptName={promptName ?? ""}
                              setPromptId={(id)=>{handleChange({target:{name:'websiteResearchPromptId', value:id}}); setPromptId(id);}}
                              setPromptType={() => { }}
                              setPromptName={() => { }}
                              label="Website Research Prompt"
                              fullWidth={true}
                              size="small"
                              sx={{ mt: 2 }}
                          />
                        <TextField 
                            label="Website URL"
                            value ={inputData.websiteUrl || ""}
                            onChange={(e) => {handleChange({target:{name:'websiteUrl', value:e.target.value}}); setWebsiteUrl(e.target.value)}}
                            size="small"
                            fullWidth
                            inputProps={{ autoComplete: 'off' }}
                            />
                      </Stack>
                      {/* Hidden: First Fact Development dropdown + Number of Reviews
                      <Stack spacing={2}>
                          <PromptSelectDropdown
                              responsePrompts={nextPromt}
                              promptId={inputData.factDevelopmentPromptId1 ?? ""}
                              promptName={nextPromptName ?? ""}
                              setPromptId={(id) => { handleChange({ target: { name: 'factDevelopmentPromptId1', value: id } }); setNextPromptId(id); }}
                              setPromptType={() => { }}
                              setPromptName={() => { }}
                              label="Fact Development Prompt"
                              fullWidth={true}
                              size="small"
                              disabled={!inputData.websiteResearchPromptId}
                              sx={{ mt: 2 }}
                          />
                          <TextField
                              label="Number of Reviews"
                              value={inputData.reviewCount1 || ""}
                              onChange={(e) => { handleChange({ target: { name: 'reviewCount1', value: e.target.value } }); handleFirstCountChange(e) }}
                              size="small"
                              fullWidth
                              inputProps={{ autoComplete: 'off' }}
                          />
                      </Stack>
                      */}
                    {/* <Typography variant="body2" color="textSecondary" sx={{textAlign:'center'}}>
                        OR
                    </Typography>
                    <TextField
                        label="Previous Response ID"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={previousResponseId || ""}
                        onChange={(e) =>{ handleChange({target:{name:'previousResponseId', value:e.target.value}}); setPreviousResponseId(e.target.value); setNextPromptId(null);}}
                        disabled={!promptId }
                    /> */}
                      <Box sx={{display:'flex', justifyContent:'space-between', gap:3, alignItems:'center'}}>
                          <Button
                              variant="contained"
                              color="primary"
                              onClick={() => {handleExecutePrompt("researchPrompt")}}
                              style={{ textTransform: 'none' }}
                              disabled={!inputData?.websiteResearchPromptId || loadingExecutePromptMultiple}
                                loading={loadingExecutePromptMultiple}
                          >
                              Execute WR Prompt
                          </Button>

                         {/* Hidden: Website Research ResponseId + copy icon
                         {previousResponseIds && <Stack direction={'column'} spacing={0} position={'relative'}>
                             
                                  <Typography variant="body2" color="textSecondary" sx={{maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{`Website Research ResponseId: `}</Typography>
                                  
                                <Box sx={{display:'flex', alignItems:'center' , gap:1}}>
                                    <Typography variant="body2" color="textSecondary" sx={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                      <Tooltip title={previousResponseIds} arrow disableInteractive placement="bottom-start">
                                           {previousResponseIds}
                                      </Tooltip>
                                  </Typography>
                                  
                                  <Tooltip title="Copy Website Research Response ID" arrow disableInteractive>
                                      <IconButton onClick={handleResponseIdCopy} sx={{padding:0}}>
                                          <ContentCopyIcon />
                                      </IconButton>
                                  </Tooltip>
                              </Box>
                          {isCopied && <Typography sx={{position:'absolute', top:'40px', right:'-10px'}} className="text-muted">Id Copied</Typography>}
                            </Stack>}
                         */}
                      </Box>
                </Stack>

                {/* Hidden: OR + Radio + Website Research Response ID */}
                 <Stack spacing={2} sx={{ mt: 4 }}>
                      <PromptSelectDropdown
                          responsePrompts={nextPromt}
                          promptId={inputData?.factDevelopmentPromptId2 ?? ""}
                          promptName={nextPromptName ?? ""}
                          setPromptId={(id)=>{handleChange({target:{name:'factDevelopmentPromptId2', value:id}}); setNextPromptId2(id);}}
                          setPromptType={() => { }}
                          setPromptName={() => { }}
                          label="Fact Development Prompt"
                          fullWidth={true}
                          size="small"
                          sx={{ mt: 2 }}
                      />

                      <TextField 
                          label="Number of Reviews"
                          value ={inputData.reviewCount2 ?? 1000}
                            onChange={(e) => {handleChange({target:{name:'reviewCount2', value:e.target.value}}); handleSecondCountChange(e)}}
                            size="small"
                            fullWidth
                            inputProps={{ autoComplete: 'off' }}
                        />

                    
                      <Box>
                          <Button
                              variant="contained"
                              color="primary"
                              onClick={() => {handleExecutePrompt('responseId')}}
                              style={{ textTransform: 'none' }}
                              disabled={
                                !inputData?.factDevelopmentPromptId2 ||
                                !(parseInt(inputData?.reviewCount2, 10) > 0) ||
                                loadingExecutePromptMultiple
                              }
                          >
                              Execute FDA Prompt
                          </Button>
                      </Box>
                      <br/>
                      <Box sx={{ mt: 4, ml: 4 }}>
                          <Button
                              variant="contained"
                              color="primary"
                              onClick={() => {handleExecutePrompt('both')}}
                              style={{ textTransform: 'none' }}
                              disabled={
                                !inputData?.websiteResearchPromptId ||
                                !inputData?.factDevelopmentPromptId2 ||
                                !(parseInt(inputData?.reviewCount2, 10) > 0) ||
                                loadingExecutePromptMultiple
                              }
                          >
                              Execute WR + FDA Prompts
                          </Button>
                      </Box>
                </Stack>
            </Grid>
            {/* <Divider orientation="vertical" flexItem sx={{margin:3}}/> */}
            <Grid item xs={7}>
                  <Box sx={{ position: 'relative' }}>
                      <Tabs
                          value={selectedTab}
                          onChange={handleTabChange}
                          indicatorColor="primary"
                          textColor="primary"
                          sx={{ borderBottom: "1px solid #888" }}
                      >
                          <Tab sx={{ textTransform: 'none' }} value={1} label={"Website Research"} />
                          <Tab sx={{ textTransform: 'none' }} value={2} label={"Fact Development"} />

                      </Tabs>
                      <Box sx={{ position: 'absolute', top: 0, right: 0, display: 'flex', alignItems: 'center', height: '100%' }}>
                      <Stack direction={'row'} spacing={2}>
                           
                              <FormControl >
                                  <InputLabel>Display</InputLabel>
                                  <Select
                                      size="small"
                                      value={displayType}
                                      displayEmpty
                                      onChange={(e) => setDisplayType(e.target.value)}
                                      sx={{ minWidth: 120 }}
                                      label="Display"
                                  >
                                      <MenuItem value={"visual"}>Visual</MenuItem>
                                      <MenuItem value={"json"}>JSON</MenuItem>
                                  </Select>
                              </FormControl>
                         {<Button disabled={_.size(outputData) >0 ? false : true} variant="outlined" color="primary" sx={{ textTransform: 'none' }}  onClick={handleExport}>Export</Button>}
                         <Tooltip title={isIoCopied ? 'Copied!' : 'Copy input / output log'} arrow disableInteractive>
                             <span>
                                 <Button
                                     disabled={
                                       loadingExecutePromptMultiple ||
                                       _.size(factDevelopment?.outputData?.GPTData || factDevelopment?.outputData?.gptData || FactData?.outputData?.GPTData || FactData?.outputData?.gptData) === 0
                                     }
                                     variant="outlined"
                                     color="primary"
                                     sx={{ textTransform: 'none' }}
                                     startIcon={<ContentCopyIcon />}
                                     onClick={handleCopyInputOutput}
                                 >
                                     {isIoCopied ? 'Copied' : 'Copy Log'}
                                 </Button>
                             </span>
                         </Tooltip>

                      </Stack>
                      </Box>
                  </Box>
                {/* <Typography variant="h6" sx={{fontSize:'18px', fontWeight:'bold'}}>Output</Typography> */}

                 { <Box sx={{ p: 2 }}>
                    {/* <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: 'bold', mb: 2 }}>{selectedTab === 1 ? 'Website Research' : 'Fact Development'} Output</Typography> */}
                        {displayType === "json" && _.size(outputData) > 0 && <ReactJson
                            style={{
                                // marginTop: "20px",
                                whiteSpace: "pre-wrap",
                                // border: "1px solid #ccc",
                                minHeight: '100px',
                                overflow: 'auto',
                                minHeight: 'calc(100vh - 310px)',
                                maxHeight: "calc(100vh - 310px)"
                            }}
                            src={outputData || {}}
                            name={null}
                            theme={theme.palette.mode === 'dark' ? 'pop' : 'rjv-default'}
                            collapsed={false}
                            enableClipboard={false}
                            displayDataTypes={false}
                            />}

                        {displayType === "visual" && _.size(outputData) > 0 && <Box sx={{ 
                            whiteSpace: 'pre-wrap', 
                            overflow: 'auto', 
                            maxHeight: 'calc(100vh - 310px)', 
                            // border: '1px solid #ccc', 
                            padding: '10px', 
                            borderRadius: '4px' 
                            }}>
                          {selectedTab === 1 && _.map(outputData?.MarketingStatements ?? outputData?.WebsiteMarketingStatements, (item, index) => (
                              <Box sx={{ padding: "24px 0", borderTop: _.size(outputData?.MarketingStatements ?? outputData?.WebsiteMarketingStatements ) > 1 ? '1px solid #ccc' : 'none' }}>


                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                      <Chip label={item?.area} sx={{ mb: 1, color: '#445364', height: '24px' }} variant="outlined" />
                                      <Chip label={item?.theme} sx={{ mb: 1, color: '#445364', height: '24px' }} variant="outlined" />
                                  </Box>
                                  <Typography variant="body1">{item?.statement}</Typography>
                                  <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>Page: {item?.page}</Typography>

                              </Box>
                          ))}

                          {selectedTab === 2 && _.map(getFactsCollection(outputData), (data, key) => {
                            let finalData = _.cloneDeep(data);
                             if(!Array.isArray(data)){
                                finalData = [data];
                             }
                            return(
                              <React.Fragment key={String(key)}>
                                  <Typography variant="h6" sx={{mb:1,  marginTop: 1.5 }}>{key}</Typography>
                                  {_.map(finalData, (fact, idx) =>{ 
                                          
                                    return (
                                      <Box key={idx} sx={{ padding: "16px 0", borderTop: '1px solid #ccc',}}>
                                          <Stack direction={'row'} spacing={1} alignItems={'center'} mb={2}>
                                              <Typography variant="subtitle1" sx={{ fontWeight: '500', width: '60px' }}>If</Typography>
                                              <Typography >{fact?.If?.text}</Typography>
                                          </Stack>
                                          <Stack direction={'row'} spacing={1} >
                                              <Typography variant="subtitle1" sx={{ fontWeight: '500', width: '60px' }}>Then</Typography>
                                              <Box>
                                                    {_.map(fact?.Then, (item, i) => (
                                                        <>
                                                            <Typography key={i} sx={{marginBottom:'8px'}}>{item?.text}
                                                            <Tooltip title={`Response Info: ${item?.response_info}`} arrow disableInteractive>
                                                                <Chip label={item?.provenance} sx={{ color: '#445364', height: '20px', marginLeft: '8px' }} variant="outlined" />
                                                            </Tooltip>
                                                            </Typography>
                                                        </>
                                                    ))}
                                              </Box>
                                          </Stack>
                                      </Box>
                                  )})}
                              </React.Fragment>
                          )})}

                      </Box>}
                        
                    </Box>}
                 {/* {selectedTab === 2 && <Box sx={{ p: 2 }}>
                    <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: 'bold', mb: 2 }}>Fact Development Output</Typography>
                        { _.size(promptOutPut) > 0 && <ReactJson
                            style={{
                                // marginTop: "20px",
                                whiteSpace: "pre-wrap",
                                // border: "1px solid #ccc",
                                minHeight: '100px',
                                overflow: 'auto',
                                minHeight: 'calc(100vh - 300px)',
                                maxHeight: "calc(100vh - 300px)"
                            }}
                            src={outputData || {}}
                            name={null}
                            theme="rjv-default"
                            collapsed={false}
                            enableClipboard={false}
                            displayDataTypes={false}
                            />}
                    </Box>} */}
            </Grid>
        </Grid>
    </Box>
  );
};

export default Facts;
